const doc = [({"da":({"js":({"shared":({"table":({"row":({"order_by_dragging_is_disabled_click_to_enable":"Drag and drop er deaktiveret. Klik for at genaktivere."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;